/**
 * Cart line “Setup charge included” Why toggle (event delegation for AJAX merges).
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wf-cart-prep-why]');
    if (!btn) return;
    var wrap = btn.closest('[data-wf-cart-prep]');
    if (!wrap) return;
    var detail = wrap.querySelector('[data-wf-cart-prep-detail]');
    if (!detail) return;
    var open = detail.hasAttribute('hidden');
    if (open) detail.removeAttribute('hidden');
    else detail.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Hide' : 'Why?';
  });
})();
